module.exports = "<h1>\n  {{title}}\n</h1>\n<a routerLink=\"/car\">car</a>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 154
// module chunks = 1